import script from "./SearchSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./SearchSidebar.vue?vue&type=style&index=0&id=42f7c783&lang=scss"

const __exports__ = script;

export default __exports__